import "./index.css";
import { Dashboard } from "./components/Dashboard";
import { DemoWarningModal } from "./components/DemoWarningModal";

export function App() {
  return (
    <>
      <DemoWarningModal />
      <Dashboard />
    </>
  );
}

export default App;
